import { Building2, Users } from "lucide-react";
import Card from "@/components/ui/Card";
import Button from "@/components/ui/Button";

const SectorCard = ({
  sector,
  image,
  currentLang,
  onClick,
}) => {
  const sectorName = sector[`sector_${currentLang}`] || sector.sector_ar;
  const companiesCount = sector.companies?.length || 0;

  return (
    <Card className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-0 relative">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={sectorName}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <Card.Content className="p-8 relative z-10">
        <div className="flex items-start justify-between mb-6">
          <div className="p-4 rounded-2xl bg-white/20 backdrop-blur-sm text-white border border-white/30">
            <Building2 className="w-8 h-8" />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-white">
              {companiesCount}
            </div>
            <div className="text-sm text-white/80">
              {currentLang === "ar" ? "شركة" : 
               currentLang === "fr" ? "Entreprises" : "Companies"}
            </div>
          </div>
        </div>

        <h3 className="text-2xl font-bold text-white mb-3">
          {sectorName}
        </h3>

        <div className="mb-6">
          <p className="text-sm text-white/80 mb-3">
            {currentLang === "ar" ? "الشركات التابعة:" :
             currentLang === "fr" ? "Entreprises affiliées:" : "Affiliated Companies:"}
          </p>
          <div className="flex flex-wrap gap-2">
            {sector.companies?.slice(0, 3).map((company, cIdx) => {
              const companyName = company[
                `${currentLang === "ar" ? "ar" : currentLang === "fr" ? "fr" : "en"}`
              ] || company.ar || company.en;
              return (
                <span
                  key={cIdx}
                  className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs text-white border border-white/30"
                >
                  {companyName}
                </span>
              );
            })}
            {sector.companies?.length > 3 && (
              <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs text-white border border-white/30">
                +{sector.companies.length - 3}{" "}
                {currentLang === "ar" ? "أخرى" :
                 currentLang === "fr" ? "autres" : "more"}
              </span>
            )}
          </div>
        </div>

        <Button
          onClick={onClick}
          className="w-full bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-semibold py-3 rounded-lg transition-all duration-200 group-hover:scale-105 border border-white/30 hover:border-white/50"
        >
          <Users className="w-4 h-4 ml-2 rtl:mr-2 rtl:ml-0" />
          {currentLang === "ar" ? "ابدأ الاستثمار" :
           currentLang === "fr" ? "Commencer l'investissement" : "Start Investing"}
        </Button>
      </Card.Content>
    </Card>
  );
};

export default SectorCard;